var Enum = (function() {

  function Enum(enumerable) {
    for (var key in enumerable) {
      this[key] = enumerable[key];
      this[enumerable[key]] = key;
    }
  };

  Enum.prototype.getName = function (value) {
    return this[value];
  };

  return Enum;
}());

